"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AwardStar = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/22-Social-Medias-Rewards-Rating/08-Rewards-Awards/AwardStar1"));
var _CurrencyDollarCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/08-Money-Payments-Finance/05-Currencies/CurrencyDollarCircle"));
var _CurrencyEuroCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/08-Money-Payments-Finance/05-Currencies/CurrencyEuroCircle"));
var _CurrencyPoundCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/08-Money-Payments-Finance/05-Currencies/CurrencyPoundCircle"));
var _DiagramWaveBothDirection = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/52-Arrows-Diagrams/02-Diagrams/DiagramWaveBothDirection"));
var _GaugeDashboard = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/02-Dashboard/GaugeDashboard"));
var _Earth = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/48-Maps-Navigation/13-Earth/Earth1"));
var _LandmarkMountain = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/50-Landmarks/09-Landmarks-Asia-Australia/LandmarkMountain"));
var _LandmarkSydneyOperaHouse = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/50-Landmarks/09-Landmarks-Asia-Australia/LandmarkSydneyOperaHouse1"));
var _LegalScaleUnequal = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/07-Work-Office-Companies/10-Legal/LegalScaleUnequal1"));
var _LightBulbShine = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/28-Lamps-Lights-Fire/05-Light-Bubbles/LightBulbShine"));
var _MapsPin = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/48-Maps-Navigation/02-Maps/MapsPin1"));
var _NewspaperReadMan = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/11-Content/05-Newspapers/NewspaperReadMan"));
var _PeopleManGraduate = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/18-Avatars/01-Geometric-Men-People/PeopleManGraduate"));
var _PlaneTrip = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/23-Travel/04-Planes-Trip/PlaneTrip1"));
var _PlaneTripInternational = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/23-Travel/04-Planes-Trip/PlaneTripInternational"));
var _ProgrammingHoldCode = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/04-Programing-Apps-Websites/01-Programing/ProgrammingHoldCode"));
var _ProgrammingKeyboardType = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/04-Programing-Apps-Websites/01-Programing/ProgrammingKeyboardType"));
var _TaxiWaveBusinessman = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/47-Transportation/04-Taxi/TaxiWaveBusinessman"));
var _TeamChat = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/07-Work-Office-Companies/02-Meetings-Collaboration/TeamChat"));
var _TravelLuggage = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/23-Travel/01-Travel-Metaphor/TravelLuggage1"));
var _UserQuestion = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/16-Help/UserQuestion"));
var _VideoGamePacman = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/45-Video-Games/01-Famous-Video-Games/VideoGamePacman"));
var _SchoolTeacher = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/01-School/SchoolTeacher"));
var _SchoolTestResults = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/01-School/SchoolTestResults"));
var _StudyDesk = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/02-Studying-Learning/StudyDesk"));
var _StudyBook = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/02-Studying-Learning/StudyBook"));
var _ELearningMonitor = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/03-E-Learning/ELearningMonitor"));
var _ELearningSmartphone = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/03-E-Learning/ELearningSmartphone"));
var _ReadHome = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/04-Library-Reading/ReadHome1"));
var _ReadHuman = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/04-Library-Reading/ReadHuman"));
var _TimeClockFileEdit = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/19-Time-files/TimeClockFileEdit"));
var _PinLocation = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/48-Maps-Navigation/05-Pins/PinLocation"));
var _SingleWomanSetting = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/17-Users/04-Geometric-Full-Body-Single-User-Woman/SingleWomanSetting"));
var _CheckBadge = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/33-Form-Validation/CheckBadge"));
var _PenWrite = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/22-Edit/PenWrite"));
var _MobilePhone = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/20-Phones-Mobile-Devices/06-Mobile-Phones/MobilePhone"));
var _SingleNeutralActionsFlag = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/17-Users/13-Geomertic-Close-Up-Single-User-Actions-Neutral/SingleNeutralActionsFlag"));
var _Glasses = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/29-Clothes-Footwear-Accessories/10-Glasses/Glasses"));
var _RankingWinnerRibbon = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/22-Social-Medias-Rewards-Rating/07-Ranking/RankingWinnerRibbon"));
var _ELearningLaptop = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/36-School-Learning/03-E-Learning/ELearningLaptop"));
var _Check = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Check"));
var _TimeClockCircle = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/18-Time/TimeClockCircle1"));
var _Calendar = _interopRequireDefault(require("@berlitz/streamline-icons/lib/light/01-Interface-Essential/21-Date-Calendar/Calendar1"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

// STREAMLINE ICONS
var icons = {
  AwardStar1: _AwardStar.default,
  CurrencyDollarCircle: _CurrencyDollarCircle.default,
  CurrencyEuroCircle: _CurrencyEuroCircle.default,
  CurrencyPoundCircle: _CurrencyPoundCircle.default,
  DiagramWaveBothDirection: _DiagramWaveBothDirection.default,
  ELearningMonitor: _ELearningMonitor.default,
  ELearningSmartphone: _ELearningSmartphone.default,
  Experience: _DiagramWaveBothDirection.default,
  GaugeDashboard: _GaugeDashboard.default,
  Global: _Earth.default,
  IconEarth: _Earth.default,
  LandmarkMountain: _LandmarkMountain.default,
  LandmarkSydneyOperaHouse1: _LandmarkSydneyOperaHouse.default,
  LegalScaleUnequal1: _LegalScaleUnequal.default,
  LightBulbShine: _LightBulbShine.default,
  MapsPin1: _MapsPin.default,
  Method: _AwardStar.default,
  NewspaperReadMan: _NewspaperReadMan.default,
  PeopleManGraduate: _PeopleManGraduate.default,
  PlaneTrip1: _PlaneTrip.default,
  PlaneTripInternational: _PlaneTripInternational.default,
  ProgrammingHoldCode: _ProgrammingHoldCode.default,
  ProgrammingKeyboardType: _ProgrammingKeyboardType.default,
  ReadHome1: _ReadHome.default,
  ReadHuman: _ReadHuman.default,
  SchoolTeacher: _SchoolTeacher.default,
  SchoolTestResults: _SchoolTestResults.default,
  StudyBook: _StudyBook.default,
  StudyDesk: _StudyDesk.default,
  TaxiWaveBusinessman: _TaxiWaveBusinessman.default,
  TeamChat: _TeamChat.default,
  TravelLuggage1: _TravelLuggage.default,
  UserQuestion: _UserQuestion.default,
  VideoGamePacman: _VideoGamePacman.default,
  ClockFileEdit: _TimeClockFileEdit.default,
  LocationPin: _PinLocation.default,
  SingleUserSettings: _SingleWomanSetting.default,
  CheckBadge: _CheckBadge.default,
  PenWrite: _PenWrite.default,
  Smartphone: _MobilePhone.default,
  ActionsFlag: _SingleNeutralActionsFlag.default,
  Glasses: _Glasses.default,
  WinnerRibbon: _RankingWinnerRibbon.default,
  ELearning: _ELearningLaptop.default,
  Check: _Check.default,
  Clock: _TimeClockCircle.default,
  Calendar: _Calendar.default
};
var createIcon = function createIcon(componentKey, color, key) {
  var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'lg';
  if (componentKey in icons) {
    return /*#__PURE__*/_react.default.createElement(icons[componentKey], {
      key: key,
      color: color,
      size: size
    });
  }
  return null;
};
var _default = createIcon;
exports.default = _default;